<template>
  <div style="height: calc(100% - 2px);">
    <iframe class="w-full h-full" :src="url"></iframe>
  </div>
</template>
<script>
import GlobalConfig from "@/global/config"

export default {
  data() {
    return {
      url: `${window.location.origin}/settlement?token=${GlobalConfig.getBaseToken()}#/new-bms`
    }
  }
}
</script>